<div fxLayout="column" fxLayoutAlign="start start" style="width: 100%; height: 100%">
  <h2 mat-dialog-title *ngIf="data.title">
    {{ data.title }}
  </h2>
  <div mat-dialog-content *ngIf="data.body">
    {{ data.body }}
  </div>
  <div *ngIf="data.buttons" fxFlex></div>
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-evenly center" *ngIf="data.buttons" style="width: 100%">
    <button
      *ngFor="let button of data.buttons"
      mat-raised-button
      [mat-dialog-close]="button.value"
      (click)="(button.action)"
    >
      {{ button.label }}
    </button>
  </div>
</div>
